import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import i18n from '../../i18n/i18n';
import Select from 'react-select';
import { Button } from '@material-ui/core';
import { wentWrong } from "../../utils/ToastConfig";
import axios from '../../utils/AxiosWrapper';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import SensorDialog from './SensorDialog';
import * as Icons from '@material-ui/icons';
import ReactSelect from '../../utils/ReactSelect';
import css from './WorkPlanning/viewSensorList.module.css';
import SearchBar from 'material-ui-search-bar';
import { withRouter } from 'react-router-dom';



const commonHeaderStyle = {
    textAlign: 'center',
    textTransform: 'uppercase',
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: '#04764e',
    color: "#ffff",

};

export default class SensorList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // regionType: [], 
            stateType: [],
            showFilters: false, loading: true,
            page: 0, pageSize: 10, sorted: null, filtered: null,
            // selection: [], selectAll: false, selectedRow: [],
            totalPages: 0, totalSensors: 0,
            searchBarValue: '',
            open: false, row: {},
            data: [],
            states: [39, 19, 82, 166, 22, 873, 879, 890, 911]
        };
    }

    componentDidMount() {
        localStorage.removeItem('row');
        this.getByURL('opstina/drop_down', 'stateType');

        axios.get('api/events/add', { params: { id_vrsta_dogadjaja: 3 } });

        this.setState({ loading: false }, () => {
            this.reactTable.fireFetchData();
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.searchBarValue !== this.state.searchBarValue) {
            this.setState({
                load: true
            })
            // this.reactTable.fireFetchData();
        }
    }

    getData(url, state, instance) {
        this.setState({ data: [] });

        let filtered = [...state.filtered];
        if (this.state.searchBarValue) {
            filtered.push({ id: 'naziv', value: this.state.searchBarValue });
        }

        axios.get(`api/${url}`, {
            params: { page: state.page, pageSize: state.pageSize, sorted: state.sorted, filtered: filtered }
        })
            .then(res => {
                this.setState({
                    data: res.data.data,
                    totalPages: res.data.total_pages,
                    totalSensors: res.data.total
                });
            })
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 1 (getData): ', error);
            })
    }

    getUser() {
        let user = localStorage.getItem('user');
        let userObject = JSON.parse(user);
        !user && window.location.replace(window.location.origin);
        return userObject;
    }

    getByURL(url, obj) {
        axios.get(`api/${url}`)
            .then(res => this.setState({ [obj]: res.data.data }))
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 2 (getByURL): ', error, ', URL: ', url);
            })
    }

    handleSearchBar = (searchVal) => {
        this.setState({
            searchBarValue: searchVal
        }, () => {
            // Odmah osveži podatke nakon promene pretrage
            if (this.reactTable) {
                this.reactTable.fireFetchData();
            }
        });
    }

    // isSelected = key => { return this.state.selection.includes(key); };
    onSearchClick = () => this.setState({ showFilters: !this.state.showFilters });
    onTableClick = () => this.props.history.push('/sensors');
    onMapClick = () => this.props.history.push({
        pathname: '/maps',
        state: {
            fromSensorList: true,
        }
    });

    handleButtonClick = (cell) => {
        let row = {
            naziv: cell.naziv,
            uid: cell.uid,
            dry_wet_bulb: cell._original.dry_wet_bulb,
            row: cell._index,
        }
        this.setState({ row }, () => { this.handleClick() });
    };

    handleClick = () => { this.setState({ open: !this.state.open }) };

    render() {
        let user = this.getUser();
        let stateType = this.state.stateType.map((item) => { return { label: item.naziv, value: item.id } });

        const columns = [
            { Header: i18n.t('Naziv'), accessor: 'naziv', headerStyle: commonHeaderStyle },
            { Header: i18n.t('Station ID'), accessor: 'uid', headerStyle: commonHeaderStyle },
            { Header: i18n.t('State'), accessor: 'naziv_opstina', headerStyle: commonHeaderStyle },
            { Header: i18n.t('Local government'), accessor: 'naziv_katastarska_opstina', headerStyle: commonHeaderStyle },
            { id: 'aktivan', Header: i18n.t('Active'), headerStyle: commonHeaderStyle, accessor: d => d.aktivan, Cell: ({ value }) => value != 0 ? i18n.t('Yes') : i18n.t('No') },
            {
                width: 80,
                Header: i18n.t('Data'),
                accessor: 'naziv',
                headerStyle: {
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    paddingTop: 10,
                    paddingBottom: 10,
                    backgroundColor: "#04764e",
                    color: '#FFFFFF'
                },
                Cell: cell => (
                    <Button onClick={() => this.handleButtonClick(cell.row)} style={{ backgroundColor: 'transparent', color: 'black', height: '20px', width: '30px', textTransform: 'none' }}>
                        {i18n.t('More')}
                    </Button>
                )
            },
        ];

        const url = 'sensor/read';

        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll } = this.state;
        const checkboxProps = {
            selectAll, isSelected, toggleSelection, toggleAll,
            // selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return { style: { backgroundColor: selected ? "#ACDAF1" : "inherit", alignItems: 'flex-end' } };
                }
                return {};
            },
            getTheadFilterProps: () => { return { style: { backgroundColor: '#58B4E5' } }; },
            getTheadTrProps: () => { return { style: { backgroundColor: '#04764e', color: '#FFFFFF' } }; },
        };

        // const filterOptions = {
        //     defaultFiltered:
        //         [
        //             {
        //                 id: 'naziv',
        //                 value: stateType.filter((element) => {
        //                     if (this.state.states.includes(user.id_opstina)) return element.value === user.id_opstina;
        //                 })
        //             }
        //         ]
        // };

        return (

            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

                <div className={css.searchWrap}>
                    <SearchBar
                        className={css.searchBar}
                        placeholder={i18n.t('Search by name')}
                        cancelOnEscape={true}
                        value={this.state.searchBarValue}
                        onChange={(searchValue) => this.handleSearchBar(searchValue)}
                        onCancelSearch={() => this.handleSearchBar('')}
                    />
                </div>

                <div className={css.karta}>
                    {user && Number(user.id_korisnik_grupa) !== 14 && (
                        <Button
                            style={{ backgroundColor: '#04764e', color: 'white' }}
                            onClick={() => this.onMapClick()}>
                            {i18n.t('Map')}
                            <Icons.Public className="icon-public menuIcon" style={{ marginLeft: '8px', marginRight: '-22px' }} />
                        </Button>
                    )}
                </div>

                <div style={{ border: '1px solid #cecece', backgroundColor: '#fff', margin: '30px 30px 30px 30px', borderRadius: '3px', boxSizing: 'border-box', overflow: 'hidden', boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column' }}>
                    <ReactTable ref={r => (this.reactTable = r)}
                        manual
                        data={this.state.data}
                        paging={true}
                        columns={columns}
                        keyField={'id'}
                        pageRangeDisplayed={false}
                        defaultPageSize={this.state.pageSize}
                        pageSizeOptions={[10, 25, 50, 100]}
                        pages={this.state.totalPages}
                        showPaginationBottom={true}
                        onFetchData={(state, instance) => {
                            if (this.state.loading === false) { this.getData(url, state, instance); }
                        }}
                        loading={this.state.loading}
                        className="-striped -highlight"
                        previousText={'<'}
                        nextText={'>'}
                        pageText={''}
                        loadingText={i18n.t('Loading...')}
                        noDataText={i18n.t('No rows found')}
                        ofText={i18n.t('of')}
                        showPageSizeOptions={false}
                        showPagination={true}
                        rowsText={''}
                        {...checkboxProps}
                        // {...filterOptions}
                        PreviousComponent={(props) => (
                            <button {...props} className='-btn' style={{
                                backgroundColor: '#4FA2CD',
                                color: '#FFFFFF'
                            }}>{props.children}</button>
                        )}
                        NextComponent={(props) => (
                            <button {...props} className='-btn' style={{
                                backgroundColor: '#4FA2CD',
                                color: '#FFFFFF'
                            }}>{props.children}</button>
                        )}
                        getTrProps={() => {
                            return {
                                style: {
                                    textAlign: 'center',
                                    paddingLeft: '10px',
                                    height: '50px',
                                    alignItems: 'center',
                                    overflowY: 'hidden',
                                    overflowX: 'hidden',
                                }
                            };
                        }}


                        onPageChange={() => {
                            this.state.load = true;
                        }}

                        NoDataComponent={() => (
                            <div style={{
                                textAlign: 'center', padding: '20px', display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop: -300
                            }}>
                                {!this.state.load && <span>{i18n.t('No rows found')}</span>}
                            </div>
                        )}
                    />
                </div>
                {this.state.open && <SensorDialog open={this.state.open} handleClick={this.handleClick} row={this.state.row} />}
            </div>
        )
    }
};
